<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Image from '@uiKit/elements/Image.vue'

import logo from '@assets/images/logo.png'
import slicealText from '@assets/images/sliceal-text.png'
</script>

<template>
  <Box class="auth-top-header">
    <Box class="auth-top-header__brand">
      <Image :src="logo" width="38" height="38" class="auth-top-header__logo-icon" />
      <Image :src="slicealText" width="150" height="34" class="auth-top-header__logo-text" />
    </Box>
  </Box>
</template>

<style scoped>
.auth-top-header {
  height: 70px;
  display: flex;
  align-items: center;
  padding: 0 2rem;
  border-bottom: 1px solid var(--p-content-border-color);
  flex-shrink: 0;
}

.auth-top-header__brand {
  display: flex;
  align-items: center;
}

.auth-top-header__logo-text {
  margin-left: -0.5rem;
}

.auth-top-header__logo-icon,
.auth-top-header__logo-text {
  object-fit: contain;
}

@media (max-width: 992px) {
  .auth-top-header {
    padding: env(safe-area-inset-top, 0) 1.25rem 0;
    height: calc(60px + env(safe-area-inset-top, 0px));
  }

  .auth-top-header__brand {
    margin: 0;
  }
}
</style>
